import { render, staticRenderFns } from "./note_add.vue?vue&type=template&id=a1cf1d4c&scoped=true&"
import script from "./note_add.vue?vue&type=script&lang=js&"
export * from "./note_add.vue?vue&type=script&lang=js&"
import style0 from "./note_add.vue?vue&type=style&index=0&id=a1cf1d4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cf1d4c",
  null
  
)

export default component.exports